import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { useQueryClient } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';

import ApolloProvider from '@/providers/apollo-provider';
import { AuthProvider, useAuth } from '@/providers/auth-provider';
import TanstackProvider from '@/providers/tanstack-provider';
import { routes } from '@/routes';

import './index.css';

const router = createRouter({
  routeTree: routes,
  defaultPreload: 'intent',
  scrollRestoration: true,
  context: {
    auth: undefined, // This will be set after we wrap the app in an AuthProvider
    queryClient: undefined,
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const App = () => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  return (
    <RouterProvider
      router={router}
      context={{ auth, queryClient }}
    />
  );
};

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <AuthProvider>
        <TanstackProvider>
          <ApolloProvider>
            <App />
          </ApolloProvider>
        </TanstackProvider>
      </AuthProvider>
    </StrictMode>
  );
}
